export { default } from '@/components/models/booking/BookingSidebar/BookingSidebarBottomContent/BookingSidebarBottomContent'
